export enum ActivityLogStatusNumber {
	Open = "Open",
	Submitted = "Submitted",
	Returned = "Returned",
	Verified = "Verified",
	Approved = "Approved",
}